import { useScrollToTop } from '../hooks/useScrollToTop';

export function ScrollToTop() {
  useScrollToTop();
  return null;
}